module.exports = __webpack_public_path__ + "static/media/wind-dial.8e45d19f.svg";